import type { FC } from 'react'
import type { ERC20Symbols } from '@g4g/wallet-modal/types'
import { classNames } from '@g4g/utils/src/react/class-names'
import PrpsDubiAmount from '../../shared/PrpsDubiAmount'

const ShoppingCartSubtotalItem: FC<{
  value: string
  label: string
  isTotal?: boolean
  'data-cy-spec'?: string
  tokenSymbol?: ERC20Symbols
}> = ({ value, label, isTotal, 'data-cy-spec': dataCySpec, tokenSymbol }) => {
  return (
    <div
      className={classNames(
        'flex items-center',
        isTotal && 'mt-2 pt-2 border-t border-gray-300/20'
      )}
    >
      <span
        className={classNames(
          'grow',
          isTotal ? 'text-lg font-bold text-white' : 'text-white/90 text-sm'
        )}
      >
        {label}
      </span>
      {isTotal ? (
        <div data-cy="shop-cart-subtotal" data-cy-spec={dataCySpec} className="flex">
          <PrpsDubiAmount
            tokenSymbol={tokenSymbol}
            amount={value}
            tokenLogoClass="w-6 h-6"
            parentClassName="space-x-1"
            textClassSize="text-xl"
          />
        </div>
      ) : (
        <span
          data-cy="shop-cart-subtotal"
          data-cy-spec={dataCySpec}
          className={classNames('font-bold text-lg', value.includes('-') && 'text-[#FF5C5C]')}
        >
          {value}
        </span>
      )}
    </div>
  )
}

const ShoppingCartSubtotal: FC<{
  total: string
  savings: string
  original: string
  tokenSymbol: ERC20Symbols
}> = ({ total, savings, original, tokenSymbol }) => {
  return (
    <div className="flex flex-col">
      <ShoppingCartSubtotalItem data-cy-spec="original" label="Original" value={original} />
      <ShoppingCartSubtotalItem
        data-cy-spec="deal-savings"
        label="Deal savings"
        value={savings ? '-' + savings : ''}
      />
      <ShoppingCartSubtotalItem
        tokenSymbol={tokenSymbol}
        data-cy-spec="total"
        label="After savings"
        value={total}
        isTotal
      />
    </div>
  )
}

export default ShoppingCartSubtotal
